module.exports = __webpack_public_path__ + "img/1509008663.ef256c77.jpg";